import { render, staticRenderFns } from "./traits_list.vue?vue&type=template&id=64b4af2a&"
import script from "./traits_list.vue?vue&type=script&lang=js&"
export * from "./traits_list.vue?vue&type=script&lang=js&"
import style0 from "./traits_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../static/blizko/local/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports